import React from "react";
import { TableRow, TableCell, Box, Skeleton } from "@mui/material";

const cellStyle = {
  padding: '10px 16px',
};

const ManualSkeleton = ({ isActiveCell }) => {
  return (
    <TableRow
      sx={{
        backgroundColor: '#fff',
        borderRadius: '10px',
      }}
    >
      <TableCell
        sx={{
          ...cellStyle,
          border: 'none',
          minWidth: '32px',
          maxWidth: '32px',
          borderRadius: '10px 0 0 10px',
        }}
      >
        <Skeleton variant="circular" width={20} height={20} />
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none' }}>
        <Skeleton width={20} />
      </TableCell> 

      {/* Member Info */}
      <TableCell sx={{ ...cellStyle, border: 'none' }}>
        <Box display="flex" alignItems="center" gap={1}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box>
            <Skeleton width={100} height={20} />
            <Skeleton width={80} height={16} />
          </Box>
        </Box>
      </TableCell>

      {/* Status */}
     {isActiveCell && ( <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton variant="rectangular" width={60} height={24} />
      </TableCell>)}
     {isActiveCell && ( <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton variant="rectangular" width={60} height={24} />
      </TableCell>)}
    <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Skeleton variant="rectangular" width={60} height={24} />
      </TableCell>  
    </TableRow>
  );
};

export default ManualSkeleton;
